import { useContext } from 'react'
import { SelectedRoofSectionContext } from '~/components/Panels/SelectedRoofSectionPanel/components/SelectedRoofSectionProvider'

export const useSelectedRoofSectionContext = () => {
  const value = useContext(SelectedRoofSectionContext)
  if (!value) throw new Error('Must be used in SelectedRoofSectionContext')
  return value
}
